import BlueprintForm from "./BlueprintForm";
import {useMutation} from "react-query";
import {createNewBlueprint,} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import Loading from "../../Loading";
import React, {useState} from "react";
import MessageModal from "../../../common/MessageModal";
import {useNavigate} from "react-router-dom";
import BasicModal from "../../demoPointEnv/BasicModal";
import {MessageModalHelper} from "../../../common/MessageHelper";

const CreateBlueprint = () => {


    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState({});
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/admin");
    };
    const {
        mutate,
        isLoading,
    } = useMutation(createNewBlueprint, (blueprint) => apiService.createBlueprint(blueprint),
        {
            onSuccess: (status) => {
                MessageModalHelper(setModal,"create", status, goBack);
                setOpen(true);
            },
        }
    );
    const onSubmit = (blueprint) => {
        mutate(blueprint);
    };


    return (
        <div>
            {isLoading ? <Loading/> :
                <div>
                    <div>Demo Point Blueprints / Create Blueprint</div>
                    {open && <MessageModal open={open} setOpen={setOpen} modal={modal}/>
                    }
                    <BasicModal/>
                    <BlueprintForm title={"Create Blueprint"} onSubmit={onSubmit}/>
                </div>
            }
        </div>
    )
}
export default CreateBlueprint;